import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgCloudIdeaSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.023 17.797a.785.785 0 01-.07.003 5.49 5.49 0 01-3.813-1.529 5.174 5.174 0 01-1.593-3.721c0-1.4.576-2.739 1.593-3.721a5.474 5.474 0 013.237-1.5C6.812 6.04 7.721 4.937 8.94 4.202a6.624 6.624 0 012.26-.845 6.85 6.85 0 012.434.006c.804.148 1.57.438 2.256.858.686.419 1.279.96 1.742 1.595.464.635.788 1.35.951 2.107.098.454.136.917.115 1.378h.135c1.12 0 2.193.45 2.983 1.247a4.268 4.268 0 011.232 3.003 4.268 4.268 0 01-1.232 3.002 4.196 4.196 0 01-2.983 1.248h-.941a.785.785 0 01-.07-.003h-1.176a5 5 0 10-8.29 0H7.023z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.751 15c0 1.228.59 2.317 1.5 3v1.286c0 .966.784 1.75 1.75 1.75h1a1.75 1.75 0 001.75-1.75V18a3.75 3.75 0 10-6-3zm1.5 0a2.25 2.25 0 113.534 1.849h-2.567A2.247 2.247 0 0110.252 15zm1.5 4.286v-.937h1.5v.937a.25.25 0 01-.25.25h-1a.25.25 0 01-.25-.25z",
    fill: "currentColor"
  })));
}

export { SvgCloudIdeaSolid as ReactComponent };
